import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, BookIcon, StarIcon } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
import { GuaranteeBox } from './GuaranteeBox';
import { useOfferTimer } from '../hooks/useOfferTimer';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const {
    isExpired,
    isInitialized
  } = useOfferTimer();
  return <>
      {/* Final CTA Section */}
      <section id="comprar" ref={ref} className="w-full py-14 md:py-28 px-6 relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #0a0a0a 0%, #0d0805 50%, #0a0a0a 100%)'
    }} data-id="element-106">
        {/* Background glow */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `radial-gradient(ellipse at 50% 50%, #CF9B2E 0%, transparent 65%)`
      }} data-id="element-107" />

        <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-108">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7
        }} data-id="element-109">
            <div className="flag-gradient h-1 w-24 mb-10 mx-auto" data-id="element-110" />

            <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-6 font-['Lato']" data-id="element-111">
              Es el momento
            </p>

            <h2 className="text-3xl md:text-6xl font-black text-[#F5F0E8] mb-4 md:mb-6 leading-tight" data-id="element-112">
              La historia de Venezuela
              <br data-id="element-113" />
              <span className="text-[#CF9B2E]" data-id="element-114">merece ser leída.</span>
            </h2>

            <p className="text-xl md:text-2xl text-[#9A9080] mb-4 leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-115">
              No dejes que el tiempo borre lo que pasó. No permitas que el
              silencio gane.
            </p>

            <p className="text-lg text-[#E8D5B0] mb-6 md:mb-12 leading-relaxed" data-id="element-116">
              Un libro que te cambiará la perspectiva para siempre.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-[#111111] border border-[#CF9B2E]/30 rounded-sm p-6 md:p-10 mb-6 md:mb-10" data-id="element-117">
            {/* 1. Star rating */}
            <div className="flex items-center justify-center gap-1 mb-4" data-id="element-118">
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-119" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-120" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-121" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-122" />
              <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-123" />
              <span className="text-[#9A9080] text-sm ml-2" data-id="element-124">
                4.9/5 basado en +8,600 lectores
              </span>
            </div>

            {/* 2. Italic closing line */}
            <p className="text-white text-lg mb-5 leading-relaxed text-center" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-125">
              Miles de lectores ya tienen su copia.La pregunta es si tú vas a
              tener la tuya.
            </p>

            {/* 3. Price block */}
            {(!isInitialized || !isExpired) && <div className="flex items-center justify-center gap-4 mb-2" data-id="element-126">
                <span className="text-[#9A9080] text-lg line-through" data-id="element-127">
                  $27.99
                </span>
                <span className="bg-[#C0392B] text-white text-xs font-bold px-3 py-1 rounded-full font-['Lato']" data-id="element-128">
                  50% OFF
                </span>
              </div>}
            <div className={`text-6xl md:text-7xl font-black mb-2 ${isExpired ? 'text-[#F5F0E8]' : 'text-[#CF9B2E]'}`} data-id="element-129">
              {'13.99 USD'}
            </div>
            <p className="text-[#9A9080] text-sm mb-5 font-['Lato']" data-id="element-130">
              Disponible en formato digital (PDF)
            </p>

            {/* 4. Guarantee block */}
            <div className="mb-5 flex justify-center" data-id="element-131">
              <GuaranteeBox data-id="element-132" />
            </div>

            {/* 5. CTA button */}
            <a href="https://templeofpages.com/es/cart/48590206533875:1" className="btn-primary inline-block w-full max-w-md px-10 py-6 text-base md:text-lg rounded-sm font-black tracking-wider" aria-label={isExpired ? 'Comprar el libro Venezuela ahora por 27.99 USD' : 'Comprar el libro Venezuela ahora por 13.99 USD'} onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Venezuela — La verdad que el mundo no quiso ver',
                content_type: 'product',
                value: isExpired ? 27.99 : 13.99,
                currency: 'USD'
              });
            }
          }} data-id="element-133">
              {'LEER EL LIBRO COMPLETO \u2014 13.99 USD'}
            </a>

            {/* 6. Payment icons + 7. SSL trust line */}
            <TrustBadges data-id="element-134" />
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-[#050505] border-t border-[#1a1a1a] py-10 px-6" data-id="element-135">
        <div className="max-w-4xl mx-auto text-center" data-id="element-136">
          <div className="flag-gradient h-px w-24 mx-auto mb-8" data-id="element-137" />
          <p className="text-[#E8D5B0] text-lg mb-6" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-138">
            "La verdad no necesita permiso para existir."
          </p>

          {/* Trust Badges — refined */}
          <div className="flex items-center justify-center gap-3 mb-8 text-[#6a6a5a] text-[10px] tracking-wider font-['Lato']" data-id="element-139">
            <div className="flex items-center gap-1.5" data-id="element-140">
              <svg viewBox="0 0 16 16" className="w-3 h-3" fill="none" stroke="#5a9a5a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-141">
                <rect x="3" y="7" width="10" height="7" rx="1.5" data-id="element-142" />
                <path d="M5 7V5a3 3 0 0 1 6 0v2" data-id="element-143" />
              </svg>
              <span data-id="element-144">SSL 256-BIT</span>
            </div>
            <span className="text-[#333]" data-id="element-145">·</span>
            <span data-id="element-146">SHOPIFY SECURE</span>
            <span className="text-[#333]" data-id="element-147">·</span>
            <span data-id="element-148">PAGO PROTEGIDO</span>
          </div>

          <p className="text-[#9A9080] text-sm font-['Lato']" data-id="element-149">
            © 2026 Nicolás Pereira — Todos los derechos reservados.
          </p>
          <p className="text-[#4a4a4a] text-xs mt-2 font-['Lato']" data-id="element-150">
            Venezuela — La verdad que el mundo no quiso ver
          </p>
        </div>
      </footer>
    </>;
}